import axios from '@/http/axios/index.js'

export default {
    list(data) {
        return axios.get('budget/departament/list', { params: data })
    },
    store(data) {
        return axios.post('budget/departament/store', data)
    },
    update(data) {
        return axios.post('budget/departament/update', data)
    },
    delete(data) {
        return axios.post('budget/departament/delete', data)
    }
}

